import { http } from 'services/http';
import { WAREHOUSE_TASKS_GET_MANY } from 'api/query-keys';
import type { TWarehouseTaskCreateReq, TWarehouseTaskRes } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useCreateWarehouseTask = () => {
  return useMutationBase<TWarehouseTaskRes, unknown, TWarehouseTaskCreateReq>({
    mutationFn: async (variables) => {
      const res = await http.post<TWarehouseTaskRes>('/v1/warehouse-tasks', variables);

      return res.data;
    },
    invalidateCallback: () => [[WAREHOUSE_TASKS_GET_MANY]],
  });
};
